// extracted by mini-css-extract-plugin
export const root = "carousel-module--root--19-Bg";
export const slider = "carousel-module--slider--YrdjS";
export const images = "carousel-module--images--3_ck8";
export const navigation = "carousel-module--navigation--3QEYE";
export const text = "carousel-module--text--3MIIA";
export const caption = "carousel-module--caption--2iPMt";
export const fraction = "carousel-module--fraction--hIw9C";